import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const SearchGlyph = /*#__PURE__*/createElement("g", {
  id: "search"
}, /*#__PURE__*/createElement("path", {
  d: "M68.6,66.4L51.8,49.6c3.2-3.7,5.1-8.5,5.1-13.7c0-11.5-9.4-20.9-20.9-20.9S15,24.4,15,35.9s9.4,20.9,20.9,20.9 c5.2,0,10-1.9,13.7-5.1l16.8,16.8c0.3,0.3,0.7,0.4,1.1,0.4s0.8-0.1,1.1-0.4C69.1,68,69.1,67,68.6,66.4z M18,35.9 C18,26,26,18,35.9,18s17.9,8,17.9,17.9s-8,17.9-17.9,17.9S18,45.8,18,35.9z"
}));
const Search = createSvg({
  name: 'search',
  path: SearchGlyph
});

export default Search;
export { SearchGlyph };
